import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import Loading from '../../Components/Loading/Loading';
import ProjectCard from './ProjectCard';

const Projects = () => {
    const { data: projects, isLoading } = useQuery({
        queryKey: ['project'],
        queryFn: async () => {
            const res = await fetch('https://abkayum-server.vercel.app/projects');
            const data = await res.json();
            return data;
        }
    })

    if (isLoading) {
        return <Loading />
    }
    return (
        <div>
            {

                <div className='flex flex-wrap place-items-center my-10 justify-center lg:h-[100vh] md:h-fit gap-8 justify-items-center")]'>
                    {
                        projects.map(project => <ProjectCard
                            key={project.id}
                            project={project}
                            projectId={project.id}
                        ></ProjectCard>)
                    }

                </div>
            }
        </div>

    );
};

export default Projects;